export default __webpack_public_path__ + "static/media/brazapay.75b4e999.ico";